import Vue from 'vue'

import Router from './router.js'
import App from './App.vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import store from './store/store.js'
import storePlugin from './store/storePlugin'
Vue.use(storePlugin)

import VueFire from 'vuefire'

//import helpersPlugin from './helpersPlugin';

import Ripple from 'vue-ripple-directive'

import VueCharts from 'vue-charts'

import Toasted from 'vue-toasted'
import Trend from 'vuetrend'

import svgicon from 'vue-svgicon'
import VueDragula from 'vue-dragula'

import Multiselect from 'vue-multiselect'

Vue.config.productionTip = false

Vue.directive('ripple', Ripple)

Vue.use(VueCharts)
Vue.use(VueDragula)
Vue.use(VueFire)
Vue.use(Toasted)
Vue.use(Trend)
Vue.use(svgicon, {
  tagName: 'svgicon'
})


Vue.component('multiselect', Multiselect)



import filters from './filters'
for(let name in filters) Vue.filter(name, filters[name])



// event bus for Non-Parent-Child-Communication
window.eventBus = new Vue()

//window.firebaseApp = firebase.initializeApp(firebaseConfig)
//const db = firebaseApp.database()
//console.log( db.ref('clients') )


/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router: Router,
//  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js